import PersistentStorage from "./persistent-storage";
import firebase from "./firebase";

const CACHE_KEY_PREFIX = "post-status";

/**
 * Get cache key for a post status
 */
const getCacheKey = (postId, type) => {
  return `${CACHE_KEY_PREFIX}:${type}:${postId}`;
};

/**
 * Get cached post status
 * Cache persists until logout or explicit invalidation
 */
const getCachedStatus = (postId, type) => {
  try {
    const key = getCacheKey(postId, type);
    const cached = PersistentStorage.getItem(key, { auth: true });
    if (!cached) return null;

    const { value } = JSON.parse(cached);
    return value;
  } catch (error) {
    console.error("Failed to get cached post status:", error);
    return null;
  }
};

/**
 * Set cached post status
 * Cache persists until logout or explicit invalidation
 */
const setCachedStatus = (postId, type, value) => {
  try {
    const key = getCacheKey(postId, type);
    const cacheData = {
      value,
    };
    PersistentStorage.setItem(key, JSON.stringify(cacheData), { auth: true });
  } catch (error) {
    console.error("Failed to set cached post status:", error);
  }
};

/**
 * Invalidate cached status for a post
 */
const invalidateStatus = (postId, type) => {
  try {
    const key = getCacheKey(postId, type);
    PersistentStorage.removeItem(key, { auth: true });
  } catch (error) {
    console.error("Failed to invalidate cached post status:", error);
  }
};

/**
 * Clear all cached post statuses for current user
 */
const clearAll = () => {
  try {
    const userId = firebase?.auth?.currentUser?.uid;
    if (!userId) return;

    // Remove all keys with the prefix for this user
    const prefix = `${userId}:${CACHE_KEY_PREFIX}:`;
    const keysToRemove = [];

    // Iterate through localStorage to find matching keys
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(prefix)) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.forEach((key) => {
      localStorage.removeItem(key);
    });
  } catch (error) {
    console.error("Failed to clear cached post statuses:", error);
  }
};

const PostStatusCache = {
  getCachedStatus,
  setCachedStatus,
  invalidateStatus,
  clearAll,
};

export default PostStatusCache;

